import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=e56a99ce&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserDrawer.vue?vue&type=style&index=0&id=e56a99ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a99ce",
  null
  
)

export default component.exports